import { Button, Modal, useMantineTheme } from "@mantine/core";
import AceEditor from "react-ace";
import { ScriptViewProps } from "../../../../../../types/types";
import { themeProvider } from "../../../../../style/utils";
import "./scriptViewModal.css";

export function ScriptViewModal(props: ScriptViewProps) {
    const theme = useMantineTheme();

    return (
        <>
            <Modal
                overlayColor={
                    theme.colorScheme === "dark"
                        ? theme.colors.dark[9]
                        : theme.colors.gray[2]
                }
                overlayOpacity={0.55}
                overlayBlur={3}
                opened={props.openedScript}
                onClose={() => props.setOpenedScript(false)}
                radius="lg"
                size="1000px"
            >
                <div className="scriptViewData">
                    <AceEditor
                        className="scriptEditor-editor"
                        aria-label="editor"
                        mode="javascript"
                        theme={theme.colorScheme === 'light' ? "github" : "solarized_dark"}
                        wrapEnabled={true}
                        name="editor"
                        fontSize={16}
                        minLines={19}
                        maxLines={19}
                        width="100%"
                        height="100%"
                        showPrintMargin={false}
                        editorProps={{$blockScrolling: true}}
                        value={props.script}
                        readOnly={true}
                    />
                </div>
                <div className="viewData-submitButton">
                    <Button sx={themeProvider} color="teal" variant="outline" onClick={()=>{props.setOpenedScript(false)}}>Close</Button>
                </div>
            </Modal>
        </>
    );
}
